import {rawRenderingLib, RenderingServices} from '@wallaby-ui/core';
import {ICellRendererParams} from 'ag-grid-community';
import classNames from 'classnames';

import entityLinkRenderer from './entity_link_renderer';
import styles from 'src/js/common/components/formatters/IconSpanWrapperLinkFormatter.less';
import stylesLinkFormatter from 'src/js/common/components/formatters/LinkFormatter.less';
import {ENCOUNTER_ROUTE} from 'src/js/containers/encounter/encounter_constants';
import {baseHaiListLinkFormatterParams} from 'src/js/lib/raw_rendering/base_hai_list_hai_link_formatter_params';

/**
 * Returns raw DOM element version of EncounterLinkFormatter component.
 * @param params
 * @param services
 * @returns {Element}
 */
export function haiListHaiLinkFormatter(
  params: ICellRendererParams,
  services: RenderingServices
) {
  const {id, label, titleText} = baseHaiListLinkFormatterParams(
    params,
    services
  );

  const iconClass = 'fas fa-bed';

  const spanElem = document.createElement('span');
  spanElem.className = styles.dlSpanWrapper;

  const iconElem = `<i class="${classNames(iconClass, styles.dlIconLink)}" />`;
  rawRenderingLib.RawRenderingService.appendChildNodeOrHtml(spanElem, iconElem);

  const divElem = document.createElement('div');
  divElem.className = stylesLinkFormatter.dlLinkFormatter;
  const textElem = rawRenderingLib.plainTextOrHtmlRenderer({
    showHtml: true,
    text: label,
    className: stylesLinkFormatter.dlLinkFormatterText,
  });
  const encounterLinkElem = entityLinkRenderer(
    {
      id,
      route: ENCOUNTER_ROUTE,
      titleText,
      suppressPadding: true,
      children: textElem,
    },
    services
  );
  rawRenderingLib.RawRenderingService.appendChildNodeOrHtml(
    divElem,
    encounterLinkElem
  );
  rawRenderingLib.RawRenderingService.appendChildNodeOrHtml(spanElem, divElem);

  return spanElem;
}
